import { Link, Text, View } from '@react-pdf/renderer';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { tv } from 'tailwind-variants';

import { Divider } from '../components/Divider';
import { tw } from '../pdf-tw';
import { commonStyles } from '../styles';

const styles = tv({
  slots: {
    horizontalRule: 'mb-4 mt-2',
    blockquote: 'my-2 border-l-4 border-gray-300 bg-gray-50 py-1 pl-3',
  },
})();

export const Heading1 = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.markdownH1())}>{children}</Text>
);

export const Heading2 = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.markdownH2())}>{children}</Text>
);

export const Heading3 = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.markdownH3())}>{children}</Text>
);

export const Heading4 = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.body())}>{children}</Text>
);

export const Heading5 = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.body())}>{children}</Text>
);

export const LineBreak = () => (
  <Text style={tw(commonStyles.body())}>{'\n'}</Text>
);

export const HorizontalRule = () => (
  <View style={tw(styles.horizontalRule())}>
    <Divider />
  </View>
);

export const Blockquote = ({ children }: { children: React.ReactNode }) => (
  <View style={tw(styles.blockquote())}>
    <Text style={tw('text-textSecondary')}>{children}</Text>
  </View>
);

export const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.body())}>{children}</Text>
);

export const Span = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw(commonStyles.body())}>{children}</Text>
);

export const Bold = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw('font-bold')}>{children}</Text>
);

export const Italic = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw('italic')}>{children}</Text>
);

export const Underline = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw('underline')}>{children}</Text>
);

export const Strikethrough = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw('line-through')}>{children}</Text>
);

export const InlineCode = ({ children }: { children: React.ReactNode }) => (
  <Text style={tw('bg-bgTertiary')}>{children}</Text>
);

export const Anchor = ({
  children,
  href,
}: {
  children: React.ReactNode;
  href: string;
}) => <Link src={href}>{children}</Link>;
